import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionLabel } from './ui/SectionLabel';
import { Book, Eye, Activity, Zap, Database } from 'lucide-react';
export function Deliverables() {
  const items = [{
    icon: Book,
    title: 'THE SOVEREIGNTY MANUAL',
    desc: 'The complete doctrine on transitioning from "Fragile" to "Antifragile."'
  }, {
    icon: Eye,
    title: 'PHASE I: CELLULAR RECONNAISSANCE',
    desc: 'How to audit your environment and identify your specific biological leakages.'
  }, {
    icon: Activity,
    title: 'PHASE II: THE DAILY SHIELD CHECKLIST',
    desc: 'A 6-minute morning routine to prime your "Defensive Energy" for the day.'
  }, {
    icon: Zap,
    title: 'PHASE III: THE 72-HOUR RAPID RESPONSE',
    desc: 'The "Break-Glass" protocol to deploy at the first sign of a system breach to stop a pathogen in its tracks.'
  }, {
    icon: Database,
    title: 'THE ZERO-RELIANCE DIRECTORY',
    desc: 'A vetted list of raw herbal sources and labs to ensure you have a "Sovereign Supply Chain" that bypasses Amazon.'
  }];
  return <section className="py-14 md:py-16 bg-bio-black bg-hex-pattern" data-id="element-36">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-37">
        <FadeIn data-id="element-38">
          <SectionLabel text="ASSETS // WHAT YOU GET" data-id="element-39" />
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-40">
            PROTOCOL DELIVERABLES
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-41">
          {items.map((item, i) => {
          const Icon = item.icon;
          // Make the first item span full width on mobile, 2 cols on tablet
          const isFirst = i === 0;
          return <FadeIn key={i} delay={i * 0.1} className={isFirst ? 'md:col-span-2 lg:col-span-1' : ''} data-id="element-42">
                <div className="group relative h-full border border-bio-gray/40 bg-bio-panel/80 backdrop-blur-sm p-8 hover:border-bio-teal/50 transition-all duration-300 hover:-translate-y-1" data-id="element-43">
                  {/* Corner accents */}
                  <div className="absolute top-0 left-0 w-2 h-2 border-t border-l border-bio-teal opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-44" />
                  <div className="absolute bottom-0 right-0 w-2 h-2 border-b border-r border-bio-teal opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-45" />

                  <div className="mb-6 inline-block p-3 bg-bio-black border border-bio-gray group-hover:border-bio-teal/50 transition-colors" data-id="element-46">
                    <Icon className="w-6 h-6 text-bio-teal" data-id="element-47" />
                  </div>

                  <h3 className="text-lg font-bold text-white mb-3 tracking-wide" data-id="element-48">
                    {item.title}
                  </h3>
                  <p className="text-bio-muted font-light text-sm leading-relaxed" data-id="element-49">
                    {item.desc}
                  </p>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}